import React, { useEffect } from "react";
import {useHistory} from "react-router-dom";

const Pay = () => {
  const history = useHistory();
    useEffect(() => {
      setTimeout(() => {
        history.replace("/home")
      }, 5000);
    }, []);
  return (
    <div>
      <div className="please-wait" style={{ color: "white" }}>
        Please wait... Do not close !!!
      </div>
      <div id="cover-spin"></div>
    </div>
  );
};

export default Pay;
